import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AdminLayout from "@/components/AdminLayout";
import { api } from "@/lib/api";
import { Search, Plus } from "lucide-react";

export default function AdminSocieties() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => { (async () => {
    const { data } = await api.get("/admin/societies");
    setRows(data);
  })(); }, []);

  const filtered = rows.filter((s) => !q || s.name.toLowerCase().includes(q.toLowerCase()) || s.slug.includes(q.toLowerCase()));

  return (
    <AdminLayout
      subtitle="Directory"
      title="All Societies"
      actions={
        <Link to="/admin/societies/new" data-testid="new-society-cta"
          className="inline-flex items-center gap-2 rounded-full bg-terracotta hover:bg-terracotta-hover text-white px-5 py-2.5 text-sm font-medium">
          <Plus size={16}/> New society
        </Link>
      }
    >
      <div className="mb-6 relative max-w-md">
        <Search size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-stone-400"/>
        <input placeholder="Search by name or slug" value={q} onChange={(e) => setQ(e.target.value)}
          data-testid="societies-search"
          className="w-full rounded-full border border-stone-300 bg-white pl-11 pr-4 py-2.5 text-sm focus:border-terracotta focus:ring-2 focus:ring-terracotta/20 outline-none"/>
      </div>
      <div className="bg-white border border-stone-200 rounded-2xl overflow-hidden">
        <table className="w-full text-left">
          <thead className="bg-sand-50 border-b border-stone-200">
            <tr>
              <Th>Society</Th><Th>Slug</Th><Th>Units</Th><Th>Status</Th><Th>Start</Th><Th>End</Th><Th></Th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((s) => (
              <tr key={s.id} className="border-b border-stone-100 hover:bg-sand-50/60" data-testid={`society-row-${s.slug}`}>
                <Td><div className="font-medium">{s.name}</div><div className="text-xs text-stone-500">{s.contact_email || s.contact_phone || "—"}</div></Td>
                <Td className="text-stone-600">{s.slug}</Td>
                <Td>{s.unit_count_at_signup ?? 0}</Td>
                <Td><StatusBadge status={s.subscription_status}/></Td>
                <Td className="text-stone-600">{s.subscription_start_date}</Td>
                <Td className="text-stone-600">{s.subscription_end_date}</Td>
                <Td><Link to={`/admin/societies/${s.id}`} className="text-terracotta hover:text-terracotta-hover text-sm">Open →</Link></Td>
              </tr>
            ))}
            {filtered.length === 0 && (
              <tr><td colSpan="7" className="p-10 text-center text-stone-500">No matching societies.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </AdminLayout>
  );
}

function StatusBadge({ status }) {
  const map = { Active: "bg-emerald-100 text-emerald-800", Suspended: "bg-amber-100 text-amber-800", Expired: "bg-red-100 text-red-800" };
  return <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium ${map[status] || "bg-stone-100 text-stone-800"}`}>{status || "—"}</span>;
}
function Th({ children }) { return <th className="text-xs uppercase tracking-wider font-semibold text-stone-500 py-4 px-5">{children}</th>; }
function Td({ children, className = "" }) { return <td className={`py-4 px-5 text-sm ${className}`}>{children}</td>; }
